import { Outlet, RouteObject } from 'react-router-dom';
import { loadable } from '@sib/ui';
import { paths } from '@sidecar/config/paths';

export const routes: RouteObject[] = [
  {
    path: paths.vendors.root,
    element: loadable(() => import('./pages/VendorsPage')),
  },
  {
    path: paths.vendors.details.root,
    element: loadable(() => import('./pages/VendorsDetailsPage')),
    children: [
      {
        path: paths.vendors.details.tab,
        element: <Outlet />,
      },
    ],
  },
];
